export default [
  {
    to: '/dashboard',
    icon: 'dashboard',
    text: 'Dashboard',
  },
  {
    to: '/contacts',
    icon: 'account',
    text: 'Contacts'
  },
  {
    to: '/groups',
    icon: 'group',
    text: 'Groups'
  },
  {
    to:'/customers',
    icon: 'customer',
    text: 'Registered Users'
  },
  {
    to: '/history',
    icon: 'history',
    text: 'History'
  },
  {
    to: '/send',
    icon: 'sms',
    text: 'Compose SMS'
  },
  {
    to: '/email/compose',
    icon: 'send',
    text: 'Compose Email'
  },
  {
    to: '/forms',
    icon: 'form',
    text: 'Forms'
  },
  {
    to: '/cloud',
    icon: 'cloud',
    text: 'Data Cloud'
  },
  {
    to: '/events',
    icon: 'calendar',
    text: 'Events and Registration'
  },
  {
    to: '/calendar',
    icon: 'calendarmulti',
    text: 'Calendar'
  },
  {
    to: '/account',
    icon: 'cogs',
    text: 'Account'
  },
  {
    to: '/emails',
    icon: 'email',
    text: 'Emails'
  },
  {
    to: '/orders',
    icon: 'orders',
    text: 'Orders'
  },
  {
    to:'/invoices',
    icon:'invoice',
    text: 'Invoicing',
    permissions:['financial']
  },
  {
    to:'/storefront',
    icon:'storefront',
    text:'My Storefront',
    permissions:['financial']
  },
  {
    to:'/pagedata',
    icon:'web',
    text:'Page Data'
  },
  {
    to:'/a4l',
    icon:'profiles',
    text:'Profiles'
  }
]